(function () {
    const spinner = document.querySelector('.index-spinner__wrap'),
        homeVideo = document.querySelector('.banner__video');

    if (homeVideo) {
        setTimeout(hideSpinner, 3000);
    }

    function hideSpinner() {
        spinner.style.display = "none";
    }
})();
